import { render, staticRenderFns } from "./CargarEquiposAnterior.vue?vue&type=template&id=3af74318"
import script from "./CargarEquiposAnterior.vue?vue&type=script&setup=true&lang=js"
export * from "./CargarEquiposAnterior.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports